export const CopyIconSVG = ({
  color = 'white',
  ...params
}: { color?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width="17"
      height="20"
      viewBox="0 0 17 20"
      {...params}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
        d="M6 1.5H15C15.2761 1.5 15.5 1.72386 15.5 2V14C15.5 14.2761 15.2761 14.5 15 14.5H14.5V16H15C16.1046 16 17 15.1046 17 14V2C17 0.895431 16.1046 0 15 0H6C4.89543 0 4 0.895431 4 2V2.5H5.5V2C5.5 1.72386 5.72386 1.5 6 1.5Z"
      />
      <rect
        x="0.75"
        y="4.75"
        width="11.5"
        height="14.5"
        rx="1.25"
        strokeWidth="1.5"
        stroke={color}
      />
    </svg>
  )
}
